import { render, staticRenderFns } from "./privacyGameView.vue?vue&type=template&id=188c1428"
import script from "./privacyGameView.vue?vue&type=script&lang=js"
export * from "./privacyGameView.vue?vue&type=script&lang=js"
import style0 from "./privacyGameView.vue?vue&type=style&index=0&id=188c1428&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports